import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "./Footer";

const MyReferrals = () => {
  const navigate = useNavigate();
  const [referralData, setReferralData] = useState({
    totalCashback: 0,
    friendsJoined: 0,
  });

  useEffect(() => {
    // baad me yaha API call lagega, jaise:
    // const fetchReferralData = async () => {
    //   const res = await axios.post(`${process.env.REACT_APP_API}website/referral_stats`, { user_id: _id });
    //   if (res.data?.result) setReferralData(res.data.data);
    // };
    // fetchReferralData();
  }, []);

  const hasReferrals = referralData.friendsJoined > 0;

  return (
    <>
      <nav className="myref-breadcrumb">
        <div className="container">
          <span onClick={() => navigate("/")}>Home</span> /{" "}
          <b>Referral Network</b>
        </div>
      </nav>

      <section className="myref-page">
        <div className="myref-card">
          {/* Stats row */}
          <div className="myref-stats-row">
            <div className="myref-stat-box">
              <p className="myref-stat-label">Total Referral Cashback Earned</p>
              <p className="myref-stat-value">₹{referralData.totalCashback}</p>
            </div>
            <div className="myref-stat-box">
              <p className="myref-stat-label">Number of Friends Joined</p>
              <p className="myref-stat-value">{referralData.friendsJoined}</p>
            </div>
          </div>

          {/* Empty state / content */}
          {!hasReferrals ? (
            <div className="myref-empty">
              <img
                src="/assets/images/refer/myreferal.png"
                alt="Refer a friend"
                className="myref-empty-img"
              />
              <h4>Nothing yet!</h4>
              <p className="myref-empty-text">
                Friends who shop together, save together.
                <br />
                Refer a friend today and get{" "}
                <span className="highlight">10%</span> of their earnings every
                time they shop.
                <br />
                It's a win-win.
              </p>
              <button
                className="myref-start-btn"
                onClick={() => navigate("/refer-and-earn")}
                type="button"
              >
                Start Referring Now
              </button>
            </div>
          ) : (
            <div className="myref-list">
              {/* Jab API se friends ki list milegi, yaha map karke render karenge */}
              <p>Aapke referrals yaha list honge.</p>
            </div>
          )}
        </div>
      </section>

      <Footer />

      <style jsx>{`
        * {
          box-sizing: border-box;
        }

        .myref-breadcrumb {
          padding: 12px 0;
          font-size: 0.9rem;
          color: #555;
        }
        .myref-breadcrumb span {
          cursor: pointer;
          color: var(--primary, #2f5bff);
        }

        .myref-page {
          padding: 2rem 1rem;
          max-width: 1000px;
          margin: 0 auto;
          width: 100%;
        }

        .myref-card {
          background: #fff;
          border: 1px solid #eee;
          border-radius: 14px;
          padding: 1.8rem;
          width: 100%;
        }

        .myref-stats-row {
          display: flex;
          flex-wrap: wrap;
          gap: 1.2rem;
          margin-bottom: 2rem;
        }
        .myref-stat-box {
          flex: 1;
          min-width: 220px;
          border: 1px solid #eee;
          border-radius: 12px;
          overflow: hidden;
        }
        .myref-stat-label {
          margin: 0;
          text-align: center;
          font-weight: 600;
          padding: 0.9rem;
          background: #fafafa;
          border-bottom: 1px solid #eee;
          font-size: 0.99rem;
          color: #333;
        }
        .myref-stat-value {
          margin: 0;
          text-align: center;
          padding: 1rem;
          font-size: 1.4rem;
          font-weight: 700;
          color: #2f5bff;
        }

        .myref-empty {
          text-align: center;
          padding: 2rem 1rem 1rem;
        }
        .myref-empty-img {
          max-width: 260px;
          width: 100%;
          height: auto;
          margin-bottom: 1.5rem;
        }
        .myref-empty h4 {
          font-weight: 700;
          font-size: 1.6rem;
          margin-bottom: 0.8rem;
        }
        .myref-empty-text {
          font-size: 1rem;
          color: #444;
          line-height: 1.6;
          margin-bottom: 1.5rem;
        }
        .highlight {
          color: #e53935;
          font-weight: 700;
        }

        .myref-start-btn {
          background: #2f5bff;
          color: white;
          border: none;
          border-radius: 8px;
          padding: 0.85rem 2rem;
          font-weight: 600;
          font-size: 0.95rem;
          cursor: pointer;
        }
        .myref-start-btn:hover {
          background: #1a3fd6;
        }

        @media (max-width: 600px) {
          .myref-stats-row {
            flex-direction: column;
          }
          .myref-page {
            padding: 1.2rem 0.8rem;
          }
        }
      `}</style>
    </>
  );
};

export default MyReferrals;